<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Debbie Dee was raised on a dairy farm in Delta, Ohio. She attended the University of Toledo and graduated as a dual major in biology and education. She taught at the Northwood School District for thirty-five years as a Language Arts teacher. Upon retirement, she fulfilled her dream of writing a trilogy about the Civil War. Deb married her high school sweetheart, Brian Towns, in 1980 and raised two wonderful sons, Kiel and Tyler. Kiel is married to Ashley Towns and Tyler is married to Lauren Towns. Brian and Deb moved south to North Georgia where they currently reside.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?b9562d24